var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"booking-calendar-desktop",class:{ 'nk-force-disable': _vm.loading.doingBooking }},[(_vm.ui.calendarViewType == 'week')?_c('BookingCalendarWeekDesktop'):_vm._e(),_vm._v(" "),(_vm.ui.calendarViewType == 'month')?_c('BookingCalendarMonth'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }